<div class="register-container">
  <!-- Left Panel - Brand Section -->
  <div class="brand-panel">
    <div class="brand-content">
      <div class="brand-logo">
        <div class="logo-icon">
          <i class="fas fa-graduation-cap"></i>
        </div>
        <span class="logo-text">Sudocad</span>
      </div>

      <h2 class="brand-tagline">Eğitim yolculuğunuzda size eşlik ediyoruz</h2>
      <p class="brand-description">
        Kişiselleştirilmiş öğrenme planları ve yapay zeka destekli analizlerle hedeflerinize ulaşın.
      </p>

      <ul class="benefits-list">
        <li class="benefit-item">
          <div class="benefit-icon">
            <i class="fas fa-robot"></i>
          </div>
          <div class="benefit-content">
            <h4>Yapay Zeka Desteği</h4>
            <p>Kişiselleştirilmiş çalışma programı ve performans analizi</p>
          </div>
        </li>
        <li class="benefit-item">
          <div class="benefit-icon">
            <i class="fas fa-chart-line"></i>
          </div>
          <div class="benefit-content">
            <h4>Detaylı Analizler</h4>
            <p>Güçlü ve zayıf yönlerinizi keşfet, gelişiminizi takip et</p>
          </div>
        </li>
        <li class="benefit-item">
          <div class="benefit-icon">
            <i class="fas fa-users"></i>
          </div>
          <div class="benefit-content">
            <h4>Uzman Koçluk</h4>
            <p>Deneyimli eğitmenlerden bireysel destek al</p>
          </div>
        </li>
        <li class="benefit-item">
          <div class="benefit-icon">
            <i class="fas fa-trophy"></i>
          </div>
          <div class="benefit-content">
            <h4>Başarı Odaklı</h4>
            <p>Hedeflerine ulaşan binlerce öğrenciye katıl</p>
          </div>
        </li>
      </ul>
    </div>
  </div>

  <!-- Right Panel - Register Form -->
  <div class="register-panel">
    <div class="register-form-container">
      <!-- Mobile Logo -->
      <div class="mobile-logo">
        <div class="logo-icon">
          <i class="fas fa-graduation-cap"></i>
        </div>
        <div class="logo-text">Sudocad</div>
      </div>

      <div class="form-header">
        <h1>Hesap Oluşturun</h1>
        <p>Eğitim yolculuğunuza başlayın</p>
      </div>

      <form class="register-form" [formGroup]="registerForm" (ngSubmit)="onSubmit()">
        <div class="form-row">
          <div class="form-group">
            <label class="form-label" for="regName">Ad</label>
            <div class="input-wrapper">
              <input
                type="text"
                id="regName"
                class="form-input"
                [class.input-error]="isFieldInvalid('name')"
                placeholder="Adınızı girin"
                formControlName="name"
              >
              <i class="fas fa-user input-icon"></i>
            </div>
            <div class="form-error" *ngIf="isFieldInvalid('name')">
              <span *ngIf="registerForm.get('name')?.hasError('required')">Ad alanı zorunludur</span>
              <span *ngIf="registerForm.get('name')?.hasError('minlength')">Ad en az 2 karakter olmalıdır</span>
            </div>
          </div>
          <div class="form-group">
            <label class="form-label" for="regSurname">Soyad</label>
            <div class="input-wrapper">
              <input
                type="text"
                id="regSurname"
                class="form-input"
                [class.input-error]="isFieldInvalid('surname')"
                placeholder="Soyadınızı girin"
                formControlName="surname"
              >
              <i class="fas fa-user input-icon"></i>
            </div>
            <div class="form-error" *ngIf="isFieldInvalid('surname')">
              <span *ngIf="registerForm.get('surname')?.hasError('required')">Soyad alanı zorunludur</span>
              <span *ngIf="registerForm.get('surname')?.hasError('minlength')">Soyad en az 2 karakter olmalıdır</span>
            </div>
          </div>
        </div>

        <div class="form-group">
          <label class="form-label" for="regEmail">E-posta Adresi</label>
          <div class="input-wrapper">
            <input
              type="email"
              id="regEmail"
              class="form-input"
              [class.input-error]="isFieldInvalid('email')"
              placeholder="ornek@email.com"
              formControlName="email"
            >
            <i class="fas fa-envelope input-icon"></i>
          </div>
          <div class="form-error" *ngIf="isFieldInvalid('email')">
            <span *ngIf="registerForm.get('email')?.hasError('required')">E-posta alanı zorunludur</span>
            <span *ngIf="registerForm.get('email')?.hasError('email')">Geçerli bir e-posta adresi giriniz</span>
          </div>
        </div>

        <div class="form-group">
          <label class="form-label" for="regUserName">Kullanıcı Adı</label>
          <div class="input-wrapper">
            <input
              type="text"
              id="regUserName"
              class="form-input"
              [class.input-error]="isFieldInvalid('userName')"
              [class.input-success]="usernameAvailable === true && !isFieldInvalid('userName')"
              placeholder="ornek.kullanici"
              formControlName="userName"
              (blur)="checkUsernameAvailability()"
            >
            <i class="fas fa-at input-icon"></i>
            <span class="username-status" *ngIf="isCheckingUsername">
              <i class="fas fa-spinner fa-spin"></i>
            </span>
            <span class="username-status available" *ngIf="!isCheckingUsername && usernameAvailable === true && !isFieldInvalid('userName')">
              <i class="fas fa-check-circle"></i>
            </span>
            <span class="username-status taken" *ngIf="!isCheckingUsername && usernameAvailable === false">
              <i class="fas fa-times-circle"></i>
            </span>
          </div>
          <div class="form-hint" *ngIf="!isFieldInvalid('userName') && usernameAvailable === null">
            Harf, rakam, nokta, alt çizgi ve tire kullanabilirsiniz
          </div>
          <div class="form-error" *ngIf="isFieldInvalid('userName')">
            <span *ngIf="registerForm.get('userName')?.hasError('required')">Kullanıcı adı zorunludur</span>
            <span *ngIf="registerForm.get('userName')?.hasError('minlength')">Kullanıcı adı en az 3 karakter olmalıdır</span>
            <span *ngIf="registerForm.get('userName')?.hasError('pattern') && !registerForm.get('userName')?.hasError('minlength')">Sadece harf, rakam, nokta, alt çizgi ve tire kullanabilirsiniz</span>
            <span *ngIf="registerForm.get('userName')?.hasError('usernameTaken')">Bu kullanıcı adı zaten kullanılıyor</span>
          </div>
          <div class="form-success" *ngIf="!isFieldInvalid('userName') && usernameAvailable === true">
            Bu kullanıcı adı kullanılabilir
          </div>
        </div>

        <div class="form-group">
          <label class="form-label" for="regPassword">Şifre</label>
          <div class="input-wrapper">
            <input
              [type]="showPassword ? 'text' : 'password'"
              id="regPassword"
              class="form-input"
              [class.input-error]="isFieldInvalid('password')"
              placeholder="En az 6 karakter (büyük harf, küçük harf, rakam)"
              formControlName="password"
            >
            <i class="fas fa-lock input-icon"></i>
            <button type="button" class="password-toggle" (click)="showPassword = !showPassword">
              <i class="fas" [ngClass]="showPassword ? 'fa-eye-slash' : 'fa-eye'"></i>
            </button>
          </div>
          <div class="form-error" *ngIf="isFieldInvalid('password')">
            <span *ngIf="registerForm.get('password')?.hasError('required')">Şifre alanı zorunludur</span>
            <span *ngIf="registerForm.get('password')?.hasError('minlength')">Şifre en az 6 karakter olmalıdır</span>
            <span *ngIf="registerForm.get('password')?.hasError('pattern') && !registerForm.get('password')?.hasError('minlength')">Şifre en az bir büyük harf, bir küçük harf ve bir rakam içermelidir</span>
          </div>
          <div class="password-strength" *ngIf="registerForm.get('password')?.value">
            <div class="strength-bar">
              <div class="strength-fill" [ngClass]="passwordStrength.level"></div>
            </div>
            <span class="strength-text" [ngClass]="passwordStrength.level">{{ passwordStrength.text }}</span>
          </div>
        </div>

        <div class="form-group">
          <label class="form-label" for="regConfirmPassword">Şifre Tekrar</label>
          <div class="input-wrapper">
            <input
              [type]="showConfirmPassword ? 'text' : 'password'"
              id="regConfirmPassword"
              class="form-input"
              [class.input-error]="isFieldInvalid('confirmPassword') || (registerForm.hasError('passwordMismatch') && registerForm.get('confirmPassword')?.touched)"
              placeholder="Şifrenizi tekrar girin"
              formControlName="confirmPassword"
            >
            <i class="fas fa-lock input-icon"></i>
            <button type="button" class="password-toggle" (click)="showConfirmPassword = !showConfirmPassword">
              <i class="fas" [ngClass]="showConfirmPassword ? 'fa-eye-slash' : 'fa-eye'"></i>
            </button>
          </div>
          <div class="form-error" *ngIf="isFieldInvalid('confirmPassword')">
            <span *ngIf="registerForm.get('confirmPassword')?.hasError('required')">Şifre tekrar alanı zorunludur</span>
          </div>
          <div class="form-error" *ngIf="registerForm.hasError('passwordMismatch') && registerForm.get('confirmPassword')?.touched">
            Şifreler eşleşmiyor
          </div>
        </div>

        <label class="checkbox-wrapper" [class.checkbox-error]="isFieldInvalid('termsAccepted')">
          <input type="checkbox" class="checkbox-input" formControlName="termsAccepted">
          <span class="checkbox-label">
            <a href="javascript:void(0)">Kullanım şartlarını</a> ve <a href="javascript:void(0)">Gizlilik Politikasını</a> okudum, kabul ediyorum.
          </span>
        </label>
        <div class="form-error" *ngIf="isFieldInvalid('termsAccepted')" style="margin-top: -0.5rem;">
          Kullanım şartlarını kabul etmeniz gerekiyor
        </div>

        <button type="submit" class="btn-register" [disabled]="isLoading">
          <span *ngIf="!isLoading">Kayıt Ol</span>
          <span *ngIf="isLoading"><i class="fas fa-spinner fa-spin"></i> Kayıt yapılıyor...</span>
        </button>
      </form>

      <div class="form-footer">
        <p>Zaten hesabınız var mı? <a routerLink="/account/login">Giriş Yapın</a></p>
      </div>
    </div>
  </div>
</div>
